/**
 * padLeft: 在数字左边补零
 * ridLeft: 去掉数字左边零
 * ridCommaForNumber： 去掉数字的逗号
 * padArray: 扩展数组长度
 * validateNumber: 判断是否数字
 * validateEmail: 验证邮箱是否合法
 * validatePhoneNumber:验证手机号码是否合法
 * validateIdentityCard:验证IDcard号码
 * validateUrl: 验证url是否合法
 * countStringLength: 计算字符串长度，兼容中文
 * validateStringLength: 检查字符串长度
 * getFileSize: 获取文件大小
 * getSizeByFileObj:根据文件对象获取文件大小
 * getFileSuffix: 获取文件后缀
 * getFileSuffixByFileObj:根据文件对象获取文件后缀
 * validateImageFile: 检验图片规格
 * convertSecondToColonSeparatedString: 把秒数转换成冒号分隔的字符串
 * validateDate: 检查日期
 * formatDate: 格式化日期
 * LocalTimeToUTCTime: 本地时间转UTC时间
 * UTCTimeToLocalTime: UTC时间转本地时间
 * getQueryStringParams: 获取url地址的query信息
 */

var Utils = module.exports = {
    /**
     * 在数字左边补零
     * @param number 数字
     * @param length 补零后的字符串总长度
     * @returns {string} 补零后的字符串
     */
    //写cookies
    setCookie: (name, value, expiredTime) => {
      let Days = 30;
      let exp = new Date();
      exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
      let _expiredTime = expiredTime ? expiredTime : exp;
      document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + _expiredTime.toUTCString();
    },
    //读cookies
    getCookie: name => {
      let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if (arr = document.cookie.match(reg))
        return decodeURIComponent(arr[2]);
      else
        return null;

    },
    //删除cookies
    delCookie: name => {
      let exp = new Date();
      let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      let cval = (arr = document.cookie.match(reg)) ? encodeURIComponent(arr[2]) : null;
      exp.setTime(exp.getTime() - 1);
      if (cval !== null)
        document.cookie = name + "=" + cval + ";expires=" + exp.toUTCString();
    },
    padLeft(number, length) {
        var string = number.toString();

        while (string.length < length) {
            string = '0' + string;
        }

        return string;
    },
    /**
     * 去掉数字左边零
     * @param number 数字
     * @returns {string} 补零后的字符串
     */
    ridLeft(number) {
        var string = number.toString();

        string = string.replace(/\b(0+)/gi, '');    // 去掉字符串前面的0

        return string;
    },
    /**
     * 去掉数字的逗号
     * @param number 数字
     * @returns {string} 去掉逗号字符串
     */
    ridCommaForNumber(number) {
        var string = number.toString();

        string = string.replace(',', '');    // 去掉字符串里的','

        return string;
    },
    /**
     * 扩展数组长度
     * @param array 数组
     * @param length 变更后长度
     * @param content 扩展加插的元素，默认为''
     * @returns {Array} 扩展后的数组
     */
    padArray(array, length, content) {
        content === undefined ? '' : content;
        array.length = length;
        for (var i = 0; i < array.length; i++) {
            array[i] === undefined ? array[i] = content : '';
        }

        return array;
    },
    /**
     * 判断是否数字
     *
     * @param str
     * @returns
     */
    validateNumber(str) {
        return /^[0-9]$/.test(str);
    },
    /**
     * 验证邮箱是否合法
     * @param email 邮箱
     * @returns {boolean} 是否合法
     */
    validateEmail(email) {
        return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
    },

    /**
     * 验证手机号码格式
     * @param phone 手机号码
     * @returns {boolean} 是否合法
     */
    validatePhoneNumber(phone) {
        return /^[0-9]{6,12}$/.test(phone);
    },

    /**
     * 验证IDcard格式
     * @param identityCard idcard号码
     * @returns {boolean} 是否合法
     */
    validateIdentityCard(identityCard) {
        return /^[0-9]{13}$/.test(identityCard);
    },

    /**
     * 验证url是否合法
     * @param url url地址
     * @returns {boolean} 是否合法
     */
    validateUrl(url){
    	return /[a-z]+:\/\/[a-z0-9_\-\/.%]+/i.test(url);

    },

    /**
     * 计算字符串长度，兼容中文
     * @param string 字符串
     * @returns {*} 长度
     */
    countStringLength(string) {
        var chineseCharacters = string.match(/[^ -~]/g);

        return string.length + (chineseCharacters ? chineseCharacters.length : 0);
    },

    /**
     * 检查字符串长度
     * @param string 字符串，min 最小值，max 最大值
     * @returns {boolean} 是否在[min, max]之间
     */
    validateStringLength(string, min, max) {
        var length = this.countStringLength(string);
        return (length < min || length > max) ? false : true;
    },

    /**
     * 获取文件大小
     * @param id 上传元素id
     * @returns {*} 文件大小, 单位为MB
     */
    getFileSize(id) {
        var imgFile = document.getElementById(id);
        if (imgFile.files[0]) {
            var size = imgFile.files[0].size / 1024 / 1024; // 初始值单位为 byte

            return size;
        } else {
            return null;
        }

    },
    /**
     * 获取文件大小
     * @param imgFile 文件对象
     * @returns
     */
    getSizeByFileObj(imgFile){
    	if (imgFile.files[0]) {
            var size = imgFile.files[0].size / 1024 / 1024; // 初始值单位为 byte

            return size;
        } else {
            return null;
        }
    },

    /**
     * 获取文件后缀
     * @param id 上传元素id
     * @returns {String} 后缀名称
     */
    getFileSuffix(id) {
        var imgFile = document.getElementById(id);
        if (imgFile.files[0]) {
            var imgFileName = imgFile.files[0].name;
            var suffix = imgFileName.substring(imgFileName.lastIndexOf('.') + 1).toLowerCase();

            return suffix;
        } else {
            return null;
        }
    },
    /**
     * 通过文件对象获取文件后缀
     * @param imgFile 文件对象
     * @returns {String} 后缀名称
     */
    getFileSuffixByFileObj(imgFile) {
        if (imgFile.files[0]) {
            var imgFileName = imgFile.files[0].name;
            var suffix = imgFileName.substring(imgFileName.lastIndexOf('.') + 1).toLowerCase();

            return suffix;
        } else {
            return null;
        }
    },


    /**
     * 检验图片规格
     * @param id 上传元素id，max 图片大小
     * @returns {boolean} 是否符合规则
     */
    validateImageFile(id, max) {
        var suffix = this.getFileSuffix(id);
        var size = this.getFileSize(id);

        if (suffix == null || size == null) {
            return false;
        }

        var imgSuffixs = ['jpg', 'png', 'jpeg'];
        var idx = imgSuffixs.indexOf(suffix);

        return (idx > -1 && size <= max);
    },
    /**
     * 通过文件对象检验图片规格
     * @param imgFile 文件对象，max 图片大小
     * @returns {boolean} 是否符合规则
     */
    validateImageByFileObj(imgFile, max) {
        var suffix = this.getFileSuffixByFileObj(imgFile);
        var size = this.getSizeByFileObj(imgFile);

        if (suffix == null || size == null) {
            return false;
        }

        var imgSuffixs = ['jpg', 'png', 'jpeg'];
        var idx = imgSuffixs.indexOf(suffix);

        return (idx > -1 && size <= max);
    },
    /**
     * 把秒数转换成冒号分隔的字符串
     * @param second 秒数
     * @param hourShouldShow {boolean} 是否显示小时，默认不显示
     * @returns {string} 冒号分隔的字符串
     */
    convertSecondToColonSeparatedString(second, hourShouldShow) {
        hourShouldShow = typeof(hourShouldShow) === 'undefined' ? false : hourShouldShow;

        var minuteString = this.padLeft(Math.floor(second % 3600 / 60).toString(), 2);
        var secondString = this.padLeft(Math.floor(second % 60).toString(), 2);
        if (hourShouldShow) {
            var hourString = this.padLeft(Math.floor(second / 3600).toString(), 2);
            return hourString + ':' + minuteString + ':' + secondString;
        }

        return minuteString + ':' + secondString;
    },

    /**
     * 检查日期
     * @param dateString 日期字符串，格式为(YYYY-MM-DD)
     * @returns {boolean} 是否符合规则 （现时判断是否为今日之后的时间）
     */
    validateDate(dateString) {
        var date = new Date(dateString.replace(/-/g, '/')),
            now = new Date(),
            gap = now.getTime() - date.getTime(),
            string = this.convertSecondToColonSeparatedString(Math.floor(gap / 1000), true),
            split = string.split(':'),
            hour = split[0] >> 0,
            min = split[1] >> 0,
            sec = split[2] >> 0;

        var flag = false;
        if (gap < 0) {
            flag = true;
        }
        else if (hour < 24) {
            flag = true;
        }

        return flag;
    },


    /**
     * 格式化日期
     * @param createdAt 数据库储存格式 例(2016-01-01 12:01:01)
     * @param isFullFormat 是否显示完整时间，默认显示。完整为(2016-01-01 12:01:01)，不完整(2016-01-01)
     * @returns {string} 格式化后的时间字符串
     */
    formatDate(createdAt, isFullFormat) {
        isFullFormat = isFullFormat === undefined ? true : isFullFormat;
        var date = new Date(createdAt);
        var mon = date.getMonth() + 1;
        var day = date.getDate();
        var hour = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();
        var timeFormatStr = this.padLeft(hour, 2) + ":" + this.padLeft(minutes, 2) + ":" + this.padLeft(seconds, 2);
        var dateFormatStr = date.getFullYear() + "-" + this.padLeft(mon, 2) + "-" + this.padLeft(day, 2) + " " + (isFullFormat ? timeFormatStr : '');

        return dateFormatStr;
    },

    /**
     * 本地时间转UTC时间
     * @param localTime 本地时间,格式为（YYYY-MM-DD hh:mm:ss / YYYY-MM-DD）
     * @param localTimezone. e.g 北京为8，巴基斯坦为5，美国东岸为-5. 默认值为null，取客户端时区
     * @returns {string} 格式化后的时间字符串
     */
    LocalTimeToUTCTime(localTime, localTimezone) {
        localTimezone = localTimezone === undefined ? null : localTimezone;

        //判断是否日期格式
        var temp = new Date(localTime);
        if (temp == 'Invalid Date') {
            return new Error('Invalid Date');
        }

        var date = temp;  //设定参考时间，以本地为准
        var timeDesignated;
        if (localTime.indexOf(':') > 0) { // 检查时候包含时分秒
            if (localTimezone === null) {
                timeDesignated = date;
            } else {
                timeDesignated = new Date(date.getTime() - localTimezone * 3600000 - date.getTimezoneOffset() * 60000).toUTCString();
                timeDesignated = new Date(timeDesignated);
            }

            var year = timeDesignated.getUTCFullYear();
            var month = timeDesignated.getUTCMonth() + 1;
            var day = timeDesignated.getUTCDate();
            var hour = timeDesignated.getUTCHours();
            var min = timeDesignated.getUTCMinutes();
            var sec = timeDesignated.getUTCSeconds();

            var timeFormatStr = this.padLeft(hour, 2) + ":" + this.padLeft(min, 2) + ":" + this.padLeft(sec, 2);
            var dateFormatStr = year + "-" + this.padLeft(month, 2) + "-" + this.padLeft(day, 2) + " " + timeFormatStr;

            return dateFormatStr;
        } else {
            //只有年月日就返回传入日期
            return localTime;
        }
    },

    /**
     * UTC时间转本地时间
     * @param UTCTime UTC时间,格式为（YYYY-MM-DD hh:mm:ss / YYYY-MM-DD）
     * @param localTimezone. e.g 北京为8，巴基斯坦为5，美国东岸为-5. 默认值为null，取客户端时区
     * @returns {string} 格式化后的时间字符串
     */
    UTCTimeToLocalTime(UTCTime, localTimezone) {
        localTimezone = localTimezone === undefined ? null : localTimezone;

        //判断是否日期格式
        var temp = new Date(UTCTime);
        if (temp == 'Invalid Date') {
            return new Error('Invalid Date');
        }

        var re = new RegExp('[a-zA-Z]');
        var date;
        if(re){
        	date = new Date(UTCTime + '+0000');  //设定参考时间，以本地为准
        } else {
        	date = new Date(UTCTime + 'Z');  //设定参考时间，以本地为准
        }

        var timeDesignated;
        if (UTCTime.indexOf(':') > 0) { // 检查时候包含时分秒
            if (localTimezone === null) {
                timeDesignated = date;
            } else {
                // 取得 UTC time
                var utc = date.getTime() + (date.getTimezoneOffset() * 60000);

                // 目标时区的时间
                timeDesignated = new Date(utc + (3600000 * localTimezone));
            }
            return this.formatDate(timeDesignated);
        } else {
            //只有年月日就返回传入日期
            return UTCTime;
        }
    },

    /**
     * 获取url地址的query信息
     * @param sParam 获取的key
     * @returns {string} 格式化后的时间字符串
     */
    getQueryStringParams(sParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] == sParam) {
                return sParameterName[1];
            }
        }
    },
  /**
   * 获取七牛图片链接
   * @param sParam 获取的key
   * @returns {string} 格式化后的时间字符串
   */
  getLink(downloadUrl) {
    /**1.获取时间戳*/
    let e = new Date().getTime() +  24 * 60 * 60 * 1000;

    /**2.获取签名  hmac-sha1算法*/
    downloadUrl = downloadUrl+ "?e=" + e;
    let AK = '4Ks52V68eqPimebKBwVK9vGf1RrlyeG7CRh19Pma';

    /**3.对上一步得到的 URL 字符串计算HMAC-SHA1签名*/
    /**let sign = hmac_sha1(downloadUrl, AK);*/

    /**4.对结果做URL 安全的 Base64 编码*/
    /** let encodedSign = urlsafe_base64_encode(sign);*/

    /**5.对计算结果处理*/
    let token = AK + ":" + '';

    return downloadUrl+"&token="+token;
  }


};




// WEBPACK FOOTER //
// ./src/lib/utils.js